import { IonPage } from '@ionic/react';
import { Report } from 'model';
import { Virtuoso } from 'react-virtuoso';
import { ReportItem } from '../../components/admin/ReportItem';

import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { AdminOnly } from '../../pages/admin/AdminOnly';
import { IconArrowBack } from '../QuirkIcons';
import { QuirkIonContent } from '../QuirkIonContent';

export const ReporterList: React.FC<{
	listOfReporters: Report[] | undefined;
	onDismiss: () => void;
}> = ({ listOfReporters, onDismiss }) => {
	return (
		<IonPage>
			<Header
				title="Reports Filter"
				left={<IconButton testId="BackButton" icon={<IconArrowBack />} onClick={() => onDismiss()} />}
			/>
			<QuirkIonContent scroll={false}>
				<AdminOnly>
					<Virtuoso
						totalCount={listOfReporters?.length}
						data={listOfReporters}
						itemContent={(index, item) => (
							<div>
								<ReportItem item={item} openModal={() => []} />
							</div>
						)}
					/>
				</AdminOnly>
			</QuirkIonContent>
		</IonPage>
	);
};
